module.exports = __webpack_public_path__ + "static/media/dr-manthi.3a5ca5d4.jpg";